import { gql } from '@apollo/client';
import { COMPANY_FRAGMENT, COMPANY_DESIGN_FRAGMENT } from 'graphql/secure/fragments';

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      ...companyValues
    }
  }
  ${COMPANY_FRAGMENT}
`;

export const UPDATE_COMPANY_CONFIGS = gql`
  mutation UpdateCompanyConfigs($input: UpdateCompanyConfigsInput!) {
    updateCompanyConfigs(input: $input) {
      company {
        id
        design {
          ...companyDesignValues
        }
        gaTrackingId
        integrationSettings {
          widgetType
          showClaims
        }
        farmDisplayOption
        siteDisplayOption
      }
    }
  }
  ${COMPANY_DESIGN_FRAGMENT}
`;

export const GENERATE_API_KEY = gql`
  mutation GenerateApiKey {
    generateApiKey {
      id
      apiKey
    }
  }
`;

export const REQUEST_PLAN_UPGRADE = gql`
  mutation RequestPlanUpgrade($message: String!) {
    requestPlanUpgrade(message: $message) {
      message
    }
  }
`;
